import { CreateSettlementRequestFields } from '../post/interfaces/createSettlementRequestFields'
import { SettlementRequestEndpoint } from '../endpoint'
import { HttpMethods } from '../../apiService/baseEndpoint'

export const getSettlementRequests = async (input: CreateSettlementRequestFields[]): Promise<any> => {
  const endpoint = new SettlementRequestEndpoint<CreateSettlementRequestFields[], undefined>('', HttpMethods.GET, input)
  return endpoint.execute()
}
